var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUeberdruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37px",
    height: "45px",
    viewBox: "-0.121 0 37 45",
    enableBackground: "new -0.121 0 37 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16.597,5.347 19.996,7.255 18.762,9.331 15.365,7.424  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "23.079,2.127 22.08,9.636 28.265,5.041  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.0872 -0.9962 0.9962 -0.0872 25.2732 29.172)",
    cx: 26.001,
    cy: 3.007,
    rx: 3.007,
    ry: 3.085
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.087 -0.9962 0.9962 -0.087 25.267 29.1724)",
    fill: "#FFFFFF",
    cx: 26.001,
    cy: 3.008,
    rx: 1.47,
    ry: 1.509
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0.718,39.761 6.902,35.166 5.904,42.675  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.0871 -0.9962 0.9962 -0.0871 -38.4043 48.3726)",
    cx: 2.963,
    cy: 41.784,
    rx: 3.007,
    ry: 3.084
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.087 -0.9962 0.9962 -0.087 -38.4041 48.3721)",
    fill: "#FFFFFF",
    cx: 2.963,
    cy: 41.783,
    rx: 1.47,
    ry: 1.508
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.67,13.649 15.066,15.557 13.834,17.633 10.437,15.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "6.502,28.98 12.594,32.4 8.394,39.477 2.304,36.059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "21.082,5.692 26.038,8.475 11.798,32.467 6.842,29.684  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.121,
    width: 37,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#E73335",
    points: "36.098,28.773 31.559,24.238 26.348,29.449 21.137,24.238  16.598,28.773 21.809,33.988 16.598,39.199 21.137,43.738 26.348,38.527 31.559,43.738 36.098,39.199 30.887,33.988  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUeberdruck);
export default __webpack_public_path__ + "static/media/noUeberdruck.edaa249d55e1e1926cc77471979db80d.svg";
export { ForwardRef as ReactComponent };